//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faSparkle, faCrown } from '@fortawesome/pro-solid-svg-icons';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';

export default {
  name: 'StudioAi',
  mixins: [AiToolsMixin],
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  data() {
    return {
      faSparkle,
      faCrown,
    };
  },
  computed: {
    pageTitle() {
      return this.$t('header.studio_ai');
    },
    pageDescription() {
      return this.$t('studio_ai.subheading');
    },
    comingSoonAiToolsText() {
      return this.comingSoonAiTools.map(({ title }) => title).join(', ');
    },
  },
};
